define.alias("shared/components/shared/wizards/device-setup/step-two", "preview-grid/components/shared/wizards/device-setup/step-two");